$(document).ready(function(){
  
  $('.imageTextContainer .fancybox').each(function(){
    $(this).data('thumb', $(this).attr('href'));
  });
  $('.imageTextContainer .fancybox').fancybox({
    'afterClose':function() {
        $('.header-container').show();
      },
      'beforeShow':function(instance, current) {
        
        instance.current.opts.caption = $(instance.current.opts.$orig[0]).attr('title');
      },
      thumbs: {
        autoStart: true, // Display thumbnails on opening
        hideOnClose: true, // Hide thumbnail grid when closing animation starts
        parentEl: ".fancybox-container", // Container is injected into this element
        axis: "y" // Vertical (y) or horizontal (x) scrolling
      }
  });

  $('.imageTextContainer .fancybox').on('click', function() {
     $('.header-container').hide();
  });
  
  $('.imageTextContainer img.clickable').on('click', function(){
    $(this).closest('.imageTextContainer').find('.buttonContainer a.fancybox').click();
  });

});
